import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {Link} from 'react-router-dom';
import intl from 'react-intl-universal';

import Button from "../../../../components/Button";

import ZoomControl from "../ZoomControl";
import DrawerButton from "../DrawerButton";
import LayerToggle from "../LayerToggle";
import DrawerContainer from "../DrawerContainer";
import MapButtons from "../MapButtons";

import './BottomContainerDesktop.css';

@inject("appStore")
@observer
class BottomContainerDesktop extends Component {
    render() {
        let questionTypes = Object.keys(this.props.appStore.appConfig.questions);
        return (
            <div className="BottomContainerDesktop">
                <div className="bottomContainer">
                    <div className="innerContainer">
                        <div className="flexContainer start mapControls">
                            {this.props.appStore.appConfig.map.zoomLocations &&
                             this.props.appStore.appConfig.map.zoomLocations.length > 0 &&
                                <MapButtons/>}

                            <ZoomControl/>

                            {Object.keys(this.props.appStore.appConfig.map.baseLayers).length > 1 &&
                                <LayerToggle
                                    inactiveTitle={this.props.appStore.appConfig.map.baseLayers[this.props.appStore.inactiveMapMode].title}
                                    inactiveStaticURL={this.props.appStore.returnLayerImage(this.props.appStore.appConfig.map.baseLayers[this.props.appStore.inactiveMapMode].static)}
                                />
                            }

                        </div>
                        <div className="drawerButtons flexContainer">
                            {questionTypes.map((type, index) =>
                                <DrawerButton key={type}
                                              questionType={type}>
                                    {type}
                                </DrawerButton>
                            )}
                        </div>
                        <div className="flexContainer end allDone">
                            <Link className={'finishedButton' + (this.props.appStore.drawer.open ? ' drawer-open ' : '') + (this.props.appStore.editMode ? ' editMode ' : '')}
                                  to={`/survey`}>
                                {intl.get("MapContainer.finish_button")}
                                <i className="fas fa-angle-right"></i>
                            </Link>
                        </div>
                    </div>
                    {this.props.appStore.drawer.open && <DrawerContainer/>}
                </div>
            </div>
        );
    }
}

export default BottomContainerDesktop;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/BottomContainerDesktop/index.js